import React, { Component } from "react";
import { connect } from "react-redux";
import EditorLabel from "editor/components/EditorLabel";

import {
  CountryContainer,
  CountryFlag,
  CountryIcon,
  PhoneInputItem,
  PhoneInputContainer,
  ContryDDI,
  DropdownContainer,
  Options,
  CountryName,
} from "./styles";

class PhoneInput extends Component {
  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      countries: [],
      showDropdown: false,
      inputValue: "",
      country: {
        iso: "BR",
        ddi: "55",
      },
    };
  }

  componentDidMount = async () => {
    const { currentValue, userPhone, updaterFn, name } = this.props;
    const { country } = this.state;

    document.addEventListener("mousedown", this.handleClickOutside);
    if (currentValue !== "") {
      const formattedValue = this.maskPhone(currentValue.number);
      this.setState({
        inputValue: formattedValue,
        country: {
          iso: currentValue.iso || country.iso,
          ddi: currentValue.ddi,
        },
      });
    } else if (userPhone) {
      const formattedValue = this.maskPhone(userPhone);
      this.setState({
        inputValue: formattedValue,
      });
      const cleaned = `${userPhone}`.replace(/\D/g, "");
      updaterFn({
        prop: name,
        value: {
          ddi: country.ddi,
          iso: country.iso,
          number: cleaned,
          string: `+${country.ddi}${cleaned}`,
        },
      });
    }

    try {
      if (localStorage.getItem("countries")) {
        this.setState({
          countries: JSON.parse(localStorage.getItem("countries")),
        });
      } else {
        const response = await fetch(
          "https://bifrost.alboompro.com/products/plataform/countries.json"
        );
        const data = await response.json();
        localStorage.setItem("countries", JSON.stringify(data));
        this.setState({
          countries: data,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.handleClickOutside);
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleCurrentCountry = (iso, ddi) => {
    const { updaterFn, name } = this.props;
    const { inputValue } = this.state;

    this.setState({
      country: {
        iso,
        ddi,
      },
      showDropdown: false,
    });

    const filteredValue = inputValue.replace(/\D/g, "");
    
    updaterFn({
      prop: name,
      value: {
        iso,
        ddi,
        number: filteredValue,
        string: `+${ddi}${filteredValue}`,
      },
    });
  };

  handleDropdown = () => {
    this.setState((state) => ({ ...state, showDropdown: !state.showDropdown }));
  };

  prefixInput = (country) => {
    return (
      <CountryContainer className="countries" onClick={this.handleDropdown}>
        <CountryFlag
          src={`https://bifrost.alboompro.com/core/flags/${country.iso.toLocaleLowerCase()}.svg`}
          alt=""
        />
        <ContryDDI>+{country.ddi}</ContryDDI>
        <CountryIcon
          src="https://icons.alboompro.com/v1/bold/arrows-diagrams/arrows/696969/arrow-down-1.svg"
          alt=""
        />
      </CountryContainer>
    );
  };

  countryDropdown = () => {
    const { locale } = this.props;
    const { countries } = this.state;
    return (
      <DropdownContainer>
        {countries.map((country) => (
          <Options
            onClick={() => this.handleCurrentCountry(country.iso, country.ddi)}
          >
            <CountryFlag
              src={`https://bifrost.alboompro.com/core/flags/${country.iso.toLocaleLowerCase()}.svg`}
              alt=""
            />
            <CountryName>{country.name[locale]}</CountryName>
            <ContryDDI style={{ color: "#A4A4A4", fontSize: "10px" }}>
              +{country.ddi}
            </ContryDDI>
          </Options>
        ))}
      </DropdownContainer>
    );
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showDropdown: false });
    }
  };

  maskPhone = (value) => {
    if (!value) return value;
    const onlyNums = value.replace(/[^\d]/g, "");

    if (onlyNums.length <= 2) return onlyNums;

    if (onlyNums.length <= 6)
      return `(${onlyNums.slice(0, 2)})${onlyNums.slice(2, 6)}`;

    if (onlyNums.length <= 10)
      return `(${onlyNums.slice(0, 2)})${onlyNums.slice(2, 6)}-${onlyNums.slice(
        6,
        10
      )}`;

    return `(${onlyNums.slice(0, 2)})${onlyNums.slice(2, 7)}-${onlyNums.slice(
      7,
      11
    )}`;
  };

  handleInputValue = (e) => {
    const { country } = this.state;
    const { updaterFn, name } = this.props;
    if (country.iso === "BR") {
      const formattedValue = this.maskPhone(e.target.value);
      this.setState({
        inputValue: formattedValue,
      });
    } else {
      this.setState({
        inputValue: e.target.value,
      });
    }
    const cleaned = `${e.target.value}`.replace(/\D/g, "");
    updaterFn({
      prop: name,
      value: {
        iso: country.iso,
        ddi: country.ddi,
        number: cleaned,
        string: `+${country.ddi}${cleaned}`,
      },
    });
  };

  render() {
    const { showDropdown, country, inputValue } = this.state;
    const { label, locale, required } = this.props;
    return (
      <section ref={this.setWrapperRef}>
        <EditorLabel>
          {label[locale]}
          {required && " *"}
        </EditorLabel>
        <PhoneInputContainer>
          <PhoneInputItem
            type="text"
            className="input"
            onChange={this.handleInputValue}
            value={inputValue}
          />
          {this.prefixInput(country)}
        </PhoneInputContainer>
        {showDropdown && this.countryDropdown()}
      </section>
    );
  }
}

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  userPhone: state.user.phone,
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInput);
